// Bilingual content for NEXCIP landing page (ID / EN)
export const TRX_URL = "https://trx.limaciptadigital.co.id/";
export const WA_NUMBER = "6285797225659";
export const WA_DISPLAY = "0857-9722-5659";
export const WA_LINK = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(
  "Halo NEXCIP, saya ingin bertanya tentang layanan top-up."
)}`;
export const LOGO_URL = "/assets/nexcip/logo.jpeg";

// App download links — swap these when the NEXCIP app is published.
export const PLAYSTORE_URL = TRX_URL;
export const APK_URL = TRX_URL;

export const waLink = (text) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

export const IMAGES = {
  pulsa:
    "/assets/nexcip/pulsa.jpeg",
  pln:
    "/assets/nexcip/pln.jpeg",
  game:
    "/assets/nexcip/game.jpeg",
  wallet:
    "/assets/nexcip/wallet.jpeg",
};

export const APP_IMAGES = {
  combo:
    "/assets/nexcip/app-combo.jpeg",
  desktop:
    "/assets/nexcip/app-desktop.jpeg",
  mobile:
    "/assets/nexcip/app-mobile.jpeg",
};

export const PARTNERS = [
  "Telkomsel", "XL Axiata", "Indosat", "Tri", "Smartfren",
  "PLN", "PDAM", "BPJS", "Mobile Legends", "Free Fire",
  "PUBG Mobile", "Genshin Impact", "OVO", "DANA", "GoPay",
  "ShopeePay", "LinkAja",
];

export const CONTENT = {
  id: {
    nav: { products: "Produk", features: "Keunggulan", how: "Cara Kerja", faq: "FAQ", contact: "Kontak" },
    cta: { login: "Masuk", register: "Daftar", start: "Mulai Transaksi" },
    promo: { text: "Promo Spesial — Bonus saldo untuk reseller baru + diskon transaksi terbatas!", cta: "Klaim Sekarang", ends: "Berakhir dalam" },
    chat: {
      title: "Ada yang bisa kami bantu?",
      subtitle: "Balas cepat via WhatsApp",
      direct: "Chat Langsung",
      directMsg: "Halo NEXCIP, saya ingin bertanya tentang layanan top-up.",
      quick: [
        { label: "Pulsa & Data", msg: "Halo NEXCIP, saya mau tanya soal Pulsa & Paket Data." },
        { label: "Token PLN", msg: "Halo NEXCIP, saya mau tanya soal Token PLN & Tagihan." },
        { label: "Top-Up Game", msg: "Halo NEXCIP, saya mau tanya soal Top-Up Game." },
        { label: "E-Wallet", msg: "Halo NEXCIP, saya mau tanya soal isi saldo E-Wallet." },
        { label: "Jadi Reseller", msg: "Halo NEXCIP, saya tertarik menjadi reseller. Mohon infonya." },
      ],
    },
    hero: {
      overline: "by Lima Cipta Digital",
      lines: ["ISI ULANG", "TANPA", "BATAS."],
      desc:
        "Platform top-up digital tercepat untuk pulsa, token listrik, top-up game, dan e-wallet. Transaksi otomatis 24 jam, harga bersaing, langsung masuk.",
      badge: "Otomatis 24/7",
    },
    marquee:
      "TRANSAKSI CEPAT • PLATFORM AMAN • DUKUNGAN 24/7 • E-WALLET • TOP-UP GAME • TOKEN PLN • PULSA & DATA •",
    products: {
      overline: "Layanan Kami",
      title: "Satu platform, semua kebutuhan digital.",
      desc: "Semua produk digital dalam satu dashboard. Cepat, otomatis, dan andal.",
      items: {
        pulsa: {
          tag: "01",
          title: "Pulsa & Paket Data",
          desc: "Semua operator — Telkomsel, XL, Indosat, Tri, Smartfren. Langsung terisi dalam hitungan detik.",
        },
        pln: {
          tag: "02",
          title: "Token PLN & Tagihan",
          desc: "Token listrik prabayar, tagihan PLN, PDAM, BPJS, dan multifinance dalam satu tempat.",
        },
        game: {
          tag: "03",
          title: "Top-Up Game",
          desc: "Mobile Legends, Free Fire, PUBG, Genshin, dan ratusan game lain. Diamond & voucher instan.",
        },
        wallet: {
          tag: "04",
          title: "E-Wallet",
          desc: "Isi saldo OVO, DANA, GoPay, ShopeePay, dan LinkAja tanpa ribet, langsung masuk.",
        },
      },
    },
    features: {
      overline: "Kenapa NEXCIP",
      title: "Dibangun untuk kecepatan & kepercayaan.",
      items: [
        { title: "Super Cepat", desc: "Sistem otomatis memproses transaksi dalam hitungan detik, kapan pun." },
        { title: "Aman & Terpercaya", desc: "Keamanan berlapis dan riwayat transaksi transparan untuk ketenangan Anda." },
        { title: "Dukungan 24/7", desc: "Tim support siap membantu setiap saat lewat WhatsApp dan portal." },
      ],
    },
    how: {
      overline: "Cara Kerja",
      title: "Tiga langkah menuju transaksi.",
      steps: [
        { n: "01", title: "Daftar Akun", desc: "Buat akun gratis di portal transaksi NEXCIP dalam satu menit." },
        { n: "02", title: "Pilih Produk", desc: "Pilih pulsa, token, top-up game, atau e-wallet yang Anda butuhkan." },
        { n: "03", title: "Transaksi Cepat", desc: "Bayar dan produk langsung masuk otomatis. Sesederhana itu." },
      ],
    },
    partners: {
      overline: "Dipercaya & Terhubung",
      title: "Terhubung dengan ratusan penyedia layanan.",
    },
    showcase: {
      overline: "Aplikasi NEXCIP",
      title: "Satu aplikasi, semua transaksi dalam genggaman.",
      desc: "Kelola transaksi dari mana saja — dashboard web yang powerful untuk reseller dan aplikasi mobile yang ringan untuk transaksi kilat. Tampilan modern, cepat, dan mudah digunakan.",
      points: ["Dashboard web real-time", "Aplikasi mobile Android", "Riwayat transaksi transparan", "Notifikasi otomatis"],
      download: { title: "Unduh Aplikasi", play: "Google Play", apk: "Download APK", note: "Segera hadir di Play Store — akses versi web sekarang." },
      slides: [
        { title: "Dashboard Web", desc: "Pantau saldo, transaksi, dan laporan lengkap dari desktop." },
        { title: "Aplikasi Mobile", desc: "Transaksi cepat kapan saja langsung dari genggaman Anda." },
        { title: "Semua Perangkat", desc: "Pengalaman mulus dari desktop hingga smartphone." },
      ],
    },
    testimonials: {
      overline: "Kata Mereka",
      title: "Dipercaya ribuan reseller di seluruh Indonesia.",
      items: [
        { quote: "Sejak pakai NEXCIP, transaksi jauh lebih cepat dan jarang gangguan. Margin reseller juga bagus.", name: "Andi Pratama", role: "Reseller, Bandung" },
        { quote: "Aplikasinya ringan dan gampang dipakai. Token PLN dan top-up game langsung masuk tanpa nunggu lama.", name: "Siti Rahayu", role: "Pemilik Konter, Majalengka" },
        { quote: "Support-nya responsif 24 jam lewat WhatsApp. Sangat membantu waktu ramai pelanggan.", name: "Budi Santoso", role: "Reseller, Cirebon" },
        { quote: "Harga bersaing dan pilihan produknya lengkap. Satu platform untuk semua kebutuhan digital.", name: "Dewi Lestari", role: "Agen Pulsa, Kuningan" },
      ],
    },
    faq: {
      overline: "Pertanyaan Umum",
      title: "Semua yang perlu Anda tahu.",
      items: [
        { q: "Bagaimana cara mulai bertransaksi?", a: "Cukup daftar akun gratis di portal transaksi NEXCIP, isi saldo, lalu pilih produk yang ingin Anda beli. Transaksi diproses otomatis dalam hitungan detik." },
        { q: "Metode pembayaran apa saja yang didukung?", a: "Kami mendukung transfer bank, virtual account, QRIS, serta berbagai e-wallet populer untuk pengisian saldo deposit Anda." },
        { q: "Berapa lama produk masuk setelah transaksi?", a: "Sebagian besar transaksi seperti pulsa, token PLN, top-up game, dan e-wallet diproses otomatis dan langsung masuk dalam hitungan detik, 24 jam sehari." },
        { q: "Apakah cocok untuk reseller?", a: "Sangat cocok. NEXCIP menyediakan harga khusus reseller, dashboard laporan, dan sistem otomatis yang andal untuk skala bisnis Anda." },
        { q: "Bagaimana jika transaksi bermasalah?", a: "Tim support kami siap membantu 24/7 melalui WhatsApp di 0857-9722-5659. Setiap transaksi tercatat transparan sehingga mudah ditelusuri." },
      ],
    },
    footer: {
      tagline: "Platform top-up digital dari Lima Cipta Digital.",
      contact: "Kontak",
      address: "Alamat",
      addressValue: "Jl. Jogja Kecil no.7 Sindang, Majalengka, Jawa Barat",
      follow: "Ikuti Kami",
      waLabel: "Chat WhatsApp",
      rights: "Seluruh hak cipta dilindungi.",
      cta: "Siap mulai? Buat akun sekarang.",
    },
  },
  en: {
    nav: { products: "Products", features: "Features", how: "How It Works", faq: "FAQ", contact: "Contact" },
    cta: { login: "Log In", register: "Sign Up", start: "Start Transacting" },
    promo: { text: "Special Promo — Balance bonus for new resellers + limited-time transaction discounts!", cta: "Claim Now", ends: "Ends in" },
    chat: {
      title: "How can we help?",
      subtitle: "Fast replies on WhatsApp",
      direct: "Chat directly",
      directMsg: "Hi NEXCIP, I'd like to ask about your top-up services.",
      quick: [
        { label: "Credit & Data", msg: "Hi NEXCIP, I'd like to ask about Credit & Data packages." },
        { label: "PLN Token", msg: "Hi NEXCIP, I'd like to ask about PLN Token & Bills." },
        { label: "Game Top-Up", msg: "Hi NEXCIP, I'd like to ask about Game Top-Up." },
        { label: "E-Wallet", msg: "Hi NEXCIP, I'd like to ask about topping up my E-Wallet." },
        { label: "Become a Reseller", msg: "Hi NEXCIP, I'm interested in becoming a reseller. Please share the details." },
      ],
    },
    hero: {
      overline: "by Lima Cipta Digital",
      lines: ["TOP UP", "WITHOUT", "LIMITS."],
      desc:
        "The fastest digital top-up platform for mobile credit, electricity tokens, game top-ups, and e-wallets. Automated 24/7, competitive prices, instant delivery.",
      badge: "Automated 24/7",
    },
    marquee:
      "FAST TRANSACTIONS • SECURE PLATFORM • 24/7 SUPPORT • E-WALLET • GAME TOP-UP • PLN TOKEN • CREDIT & DATA •",
    products: {
      overline: "Our Services",
      title: "One platform, every digital need.",
      desc: "Every digital product in a single dashboard. Fast, automated, and reliable.",
      items: {
        pulsa: {
          tag: "01",
          title: "Credit & Data",
          desc: "Every operator — Telkomsel, XL, Indosat, Tri, Smartfren. Delivered in seconds.",
        },
        pln: {
          tag: "02",
          title: "PLN Token & Bills",
          desc: "Prepaid electricity tokens, PLN, PDAM, BPJS, and financing bills in one place.",
        },
        game: {
          tag: "03",
          title: "Game Top-Up",
          desc: "Mobile Legends, Free Fire, PUBG, Genshin, and hundreds more. Instant diamonds & vouchers.",
        },
        wallet: {
          tag: "04",
          title: "E-Wallet",
          desc: "Top up OVO, DANA, GoPay, ShopeePay, and LinkAja with zero hassle, instantly.",
        },
      },
    },
    features: {
      overline: "Why NEXCIP",
      title: "Built for speed & trust.",
      items: [
        { title: "Lightning Fast", desc: "Automated systems process transactions in seconds, any time of day." },
        { title: "Safe & Trusted", desc: "Layered security and transparent transaction history for peace of mind." },
        { title: "24/7 Support", desc: "Our team is ready to help anytime via WhatsApp and the portal." },
      ],
    },
    how: {
      overline: "How It Works",
      title: "Three steps to a transaction.",
      steps: [
        { n: "01", title: "Create Account", desc: "Sign up for free on the NEXCIP transaction portal in a minute." },
        { n: "02", title: "Choose Product", desc: "Pick the credit, token, game top-up, or e-wallet you need." },
        { n: "03", title: "Fast Checkout", desc: "Pay and your product arrives instantly, automatically. That simple." },
      ],
    },
    partners: {
      overline: "Trusted & Connected",
      title: "Connected to hundreds of service providers.",
    },
    showcase: {
      overline: "The NEXCIP App",
      title: "One app, every transaction in your hand.",
      desc: "Manage transactions from anywhere — a powerful web dashboard for resellers and a lightweight mobile app for lightning-fast top-ups. Modern, fast, and easy to use.",
      points: ["Real-time web dashboard", "Android mobile app", "Transparent transaction history", "Automatic notifications"],
      download: { title: "Download the App", play: "Google Play", apk: "Download APK", note: "Coming soon on Play Store — access the web version now." },
      slides: [
        { title: "Web Dashboard", desc: "Track balance, transactions, and full reports from your desktop." },
        { title: "Mobile App", desc: "Fast transactions anytime, right from the palm of your hand." },
        { title: "Every Device", desc: "A seamless experience from desktop to smartphone." },
      ],
    },
    testimonials: {
      overline: "What They Say",
      title: "Trusted by thousands of resellers across Indonesia.",
      items: [
        { quote: "Since switching to NEXCIP, transactions are far faster with barely any downtime. The reseller margins are great too.", name: "Andi Pratama", role: "Reseller, Bandung" },
        { quote: "The app is lightweight and easy to use. PLN tokens and game top-ups arrive instantly, no waiting.", name: "Siti Rahayu", role: "Store Owner, Majalengka" },
        { quote: "Support is responsive 24 hours via WhatsApp. A huge help during busy customer hours.", name: "Budi Santoso", role: "Reseller, Cirebon" },
        { quote: "Competitive prices and a complete product range. One platform for every digital need.", name: "Dewi Lestari", role: "Credit Agent, Kuningan" },
      ],
    },
    faq: {
      overline: "Frequently Asked",
      title: "Everything you need to know.",
      items: [
        { q: "How do I start transacting?", a: "Simply create a free account on the NEXCIP portal, top up your balance, then choose the product you want. Transactions are processed automatically in seconds." },
        { q: "Which payment methods are supported?", a: "We support bank transfers, virtual accounts, QRIS, and various popular e-wallets to top up your deposit balance." },
        { q: "How fast does the product arrive?", a: "Most transactions such as credit, PLN tokens, game top-ups, and e-wallets are processed automatically and delivered within seconds, 24 hours a day." },
        { q: "Is it suitable for resellers?", a: "Absolutely. NEXCIP offers special reseller pricing, reporting dashboards, and a reliable automated system built for your business scale." },
        { q: "What if a transaction has an issue?", a: "Our support team is ready to help 24/7 via WhatsApp at 0857-9722-5659. Every transaction is transparently logged for easy tracing." },
      ],
    },
    footer: {
      tagline: "A digital top-up platform by Lima Cipta Digital.",
      contact: "Contact",
      address: "Address",
      addressValue: "Jl. Jogja Kecil no.7 Sindang, Majalengka, West Java",
      follow: "Follow Us",
      waLabel: "Chat on WhatsApp",
      rights: "All rights reserved.",
      cta: "Ready to start? Create your account now.",
    },
  },
};

export const SOCIALS = [
  { key: "instagram", label: "Instagram", handle: "@limaciptadigital", url: "https://instagram.com/limaciptadigital" },
  { key: "facebook", label: "Facebook", handle: "@limaciptadigital", url: "https://facebook.com/limaciptadigital" },
  { key: "youtube", label: "YouTube", handle: "@limaciptadigital", url: "https://youtube.com/@limaciptadigital" },
];
